import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader/Loader";
import { sendOTP } from "../Redux/Actions/userAction";
import Navbar from "./Navbar";
import React from "react";

const Login = ({ onNext }) => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.otpDetails);

  async function handleLogin() {
    // If user email is not given
    if (!email) return;

    // Send OTP to user
    dispatch(sendOTP(email));

    // Go to next step
    onNext();
  }

  if (loading) return <Loader message="Sending OTP..." />;

  return (
    <>
      <Navbar />
      <section className="h-screen lg:px-20 px-4 md:px-12">
        <div className="px-6 h-full text-gray-800">
          <div className="flex xl:justify-center lg:justify-between justify-center items-center flex-wrap h-full g-6">
            <div className="grow-0 shrink-1 md:shrink-0 basis-auto xl:w-6/12 lg:w-6/12 md:w-9/12 mb-12 md:mb-0">
              <img
                src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                className="w-full"
                alt="Sample image"
              />
            </div>
            <div className="xl:ml-20 xl:w-5/12 lg:w-5/12 md:w-8/12 mb-12 md:mb-0">
              <>
                <div className="flex flex-row items-center justify-center lg:justify-start">
                  <p className="mb-0 mr-4 font-bold text-lg">Sign In</p>
                </div>

                <div className="my-6">
                  <input
                    type="email"
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    placeholder="Mobile Number* / email ID"
                    className="form-control block w-full px-4 py-2 text-xl font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                  />
                </div>

                <div className="text-center lg:text-left">
                  <button
                    onClick={handleLogin}
                    className="inline-block px-7 py-3 bg-blue-600 text-white font-medium text-sm leading-snug uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                  >
                    Send OTP
                  </button>
                </div>
              </>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="md:w-7/12  lg:w-4/12 w-full my-10 border-2 border-gray-200  mx-auto bg-white md:p-8 p-4 shadow-lg">
        <h1 className="text-2xl  font-semibold mb-3 text-gray-600">
          <span className="font-bold text-gray-800">Login</span> or{" "}
          <span className="font-bold text-gray-800">Signup</span>
        </h1>

        <div className="f-outline px-2 relative border rounded-sm focus-within:border-gray-800">
          <input
            type="text"
            name="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            placeholder="Mobile Number* / email ID"
            className="block p-2 w-full text-lg appearance-none focus:outline-none bg-transparent"
          />
        </div>
        <div className="mt-4">
          <span>
            By continuing, I agree to the{" "}
            <span className="font-semibold text-pink-500">Terms of use</span> &{" "}
            <span className="font-semibold text-pink-500">Terms of use</span>
          </span>
        </div>
        <button
          onClick={handleLogin}
          className="text-white my-4 bg-pink-400 capitalize hover:bg-pink-500 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center "
        >
          Continue
        </button>
      </div> */}
    </>
  );
};

export default Login;
